/* eslint-disable camelcase */
import get from 'lodash/get';
import { addValueToPreconfiguredFilter } from './addValueToPreconfiguredFilter';
import { facetToBoolean } from './facets';
import { pricesToObject } from './pricesToObject';

export const getFiltersValuesProducts = (
  filters,
  searchParametersFilters,
  filtersConf,
  type_id,
  facets,
  country,
  intl
) => {
  /* we are adding prices that doesn't exist in the preconfigured prices */
  addValueToPreconfiguredFilter(
    get(searchParametersFilters, 'price_min'),
    filtersConf.prices[type_id]
  );
  addValueToPreconfiguredFilter(
    get(searchParametersFilters, 'price_max'),
    filtersConf.prices[type_id]
  );

  return {
    ...filters,
    decrease_price: facetToBoolean(facets.decrease_price),
    photos: facetToBoolean(facets.photo),
    prices_min: pricesToObject(filtersConf.prices[type_id], intl, country),
    prices_max: pricesToObject(filtersConf.prices[type_id], intl, country),
  };
};



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/utils/getFiltersValuesProducts.js